<template>
  <div>
    <div class="success">
      <div class="success-text">
          <slot name="title"></slot>
      </div>
      <div class="success-des"><span v-show="hasLine">—</span><br />
        <slot name="des"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasLine: {
      default: true
    }
  }
};
</script>

<style scoped>
.success {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}
.success-text {
  margin: 0 auto;
  font-size: 30px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #1466da;
}
.success .success-des {
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: 300;
  color: #313945;
}
@media screen and (max-width: 400px) {
  .success-text {
    font-size: 20px;
  }
}
</style>